// import {api} from '../request/api'

function downLoadFile (appCode, bizCode, url) {
  // console.log(localStorage.getItem('baseUrl'))
  // let downLoadUrl = api.baseUrl() + '/downFile?AppCode=' + appCode + '&BizCode=' + bizCode + '&filePath=' + url
  let downLoadUrl = localStorage.getItem('baseUrl') + '/downFile?AppCode=' + appCode + '&BizCode=' + bizCode + '&filePath=' + encodeURI(url)
  window.open(downLoadUrl)
}

export {downLoadFile}



// WEBPACK FOOTER //
// ./src/util/downLoadFile.js